import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUploadQuestionsStore = create(
  persist(
    (set) => ({
      isOpen: false,
      excelFile: null,
      zipFile: null,
      loading: false,

      openDialog: () => set({ isOpen: true }),
      closeDialog: () => set({
        isOpen: false,
        excelFile: null,
        zipFile: null,
        loading: false
      }),

      setLoading: (loading) => set({ loading }),

      setExcelFile: (file) => set({ excelFile: file }),
      setZipFile: (file) => set({ zipFile: file }),
      reset: () => set({
        excelFile: null,
        zipFile: null
      }),
    }),
    {
      name: 'upload-questions-storage',
      partialize: (state) => ({
        isOpen: state.isOpen
      }),
    }
  )
);

export default useUploadQuestionsStore;
